module.exports = __webpack_public_path__ + "img/pergamin_borrado.b322fe13.jpg";